module.exports = __webpack_public_path__ + "img/115.5.91072129.png";